.selectors-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    max-width: 600px;
    padding: 16px 0;
}
